"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.didUserComplete = didUserComplete;
exports.filterIncompleteSections = filterIncompleteSections;
exports.getEventDate = getEventDate;
exports.hasCertifiedOrAcknowledged = hasCertifiedOrAcknowledged;
exports.hasOutcomes = hasOutcomes;
exports.hasSomeResponse = hasSomeResponse;
exports.isAssessmentFormComplete = isAssessmentFormComplete;
exports.isSectionComplete = isSectionComplete;

var _lodash = require("lodash");

var _moment = _interopRequireDefault(require("moment"));

var _edgeEvent = _interopRequireDefault(require("../constant/relationship/edge-event.constant"));

var _label = _interopRequireDefault(require("../constant/relationship/label.constant"));

var _relationship = _interopRequireDefault(require("./relationship.helper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var EVENT = _label["default"].EDGE_TYPE.EVENT,
    OWNER = _label["default"].EDGE.OWNER,
    _RELATIONSHIP_LABEL$N = _label["default"].NODE,
    BUA = _RELATIONSHIP_LABEL$N.BUA,
    GROUP = _RELATIONSHIP_LABEL$N.GROUP,
    LAB_HAZARD = _RELATIONSHIP_LABEL$N.LAB_HAZARD,
    ROOM = _RELATIONSHIP_LABEL$N.ROOM;

function hasCertifiedOrAcknowledged() {
  var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return events.some(function (e) {
    return [_edgeEvent["default"].ACKNOWLEDGED, _edgeEvent["default"].CERTIFIED].includes(e);
  });
}

var hasAssessmentCompleted = function hasAssessmentCompleted(assessment, type) {
  switch (type) {
    case LAB_HAZARD:
      return Boolean(assessment.expirationDate);

    case BUA:
      return !['AMEND', 'AMENDMENT_DRAFT', 'DRAFT', 'RENEWAL_DRAFT'].includes(assessment.status);

    default:
      break;
  }

  return false;
};

function didUserComplete(assessment, userId, isAdmin) {
  var _ref = assessment || {},
      _ref$relationships = _ref.relationships,
      relationships = _ref$relationships === void 0 ? [] : _ref$relationships,
      status = _ref.status,
      _ref$template$assessm = _ref.template.assessmentTypeConfig,
      assessmentTypeConfig = _ref$template$assessm === void 0 ? {} : _ref$template$assessm;

  if (isAdmin) {
    return hasAssessmentCompleted(assessment, assessmentTypeConfig.type);
  }

  var events = relationships.filter(function (relationship) {
    return relationship.node.id === userId && relationship.edge.type === EVENT;
  }).map(function (l) {
    return l.edge.label;
  });

  if (assessmentTypeConfig.type === BUA) {
    return !['AMEND', 'AMENDMENT_DRAFT', 'DRAFT', 'RENEWAL_DRAFT'].includes(status) && !hasCertifiedOrAcknowledged(events);
  }

  return hasCertifiedOrAcknowledged(events);
}

function hasOutcomes(assessment) {
  var report = assessment.report.outcomes || assessment.report.summary;
  return Object.values(report).some(function (value) {
    return value.length;
  });
}

function hasSomeResponse(assessment) {
  var responses = assessment.responses;
  return responses && Object.keys(responses).length;
}

function isSectionComplete(assessment, section) {
  var responses = assessment.responses;

  if (section.questions.every(function (question) {
    return !question.required;
  })) {
    return true;
  } // TODO: check nested questions


  return responses && responses[section.key] && section.questions.every(function (question) {
    var questionResponses = responses[section.key][question.key];

    if (Array.isArray(questionResponses)) {
      return questionResponses.length > 0;
    }

    return questionResponses || !question.required;
  });
}

function filterIncompleteSections(template, assessment) {
  return template.questions.filter(function (section) {
    return !isSectionComplete(assessment, section);
  });
}

function getEventDate(assessment, eventType) {
  var isNeptune = !assessment.relationships.some(function (r) {
    return (0, _lodash.get)(r, 'events');
  });

  if (isNeptune) {
    var event = assessment.relationships.find(function (r) {
      return (0, _lodash.get)(r, 'edge.type') === EVENT && (0, _lodash.get)(r, 'edge.label') === eventType;
    });
    return event ? (0, _moment["default"])((0, _lodash.get)(event, 'edge.startDate')) : '';
  }

  var relationshipDates = assessment.relationships.filter(function (relationship) {
    return relationship.role === OWNER;
  }).reduce(function (certifiedDates, relationship) {
    var certifiedEvents = relationship.events.filter(function (e) {
      return e.event === eventType;
    });

    if (!certifiedEvents.length) {
      return certifiedDates;
    }

    return certifiedDates.concat([(0, _moment["default"])(new Date(relationship.startDate))].concat(certifiedEvents.map(function (event) {
      return (0, _moment["default"])(new Date(event.date));
    })));
  }, []);
  return relationshipDates.length ? _moment["default"].max(relationshipDates) : '';
}

function isAssessmentFormComplete(assessment) {
  var relationships = assessment.relationships,
      template = assessment.template;
  var incompleteSections = filterIncompleteSections(template, assessment);

  if (template.parentType === GROUP) {
    var hasLocations = _relationship["default"].hasAnyOfTypes(relationships, [ROOM]);

    return hasLocations && !incompleteSections.length;
  }

  return !incompleteSections.length;
}

var _default = {
  didUserComplete: didUserComplete,
  filterIncompleteSections: filterIncompleteSections,
  getEventDate: getEventDate,
  hasCertifiedOrAcknowledged: hasCertifiedOrAcknowledged,
  hasOutcomes: hasOutcomes,
  hasSomeResponse: hasSomeResponse,
  isAssessmentFormComplete: isAssessmentFormComplete,
  isSectionComplete: isSectionComplete
};
exports["default"] = _default;